import { INVALIDATE_PLAN_COMPTABLE, INVALIDATE_CLIENT } from 'actions/invalidationTags';
import { ApiMananger } from "actions/rtkquery";
import { GET_Grand_Livre,
  GET_GRAND_LIVRE_TIERS,
  GET_LIVRE_JOURNAL,
  GET_BALANCE_GENERAL,
  GET_BILAN, GET_BILAN_COMPTABLE,
  GET_CODES_COMPTABLES,
  GET_COMPTES_RESULTAT,
  GET_CODES, GET_BILAN_STRUCTURE,
  ECRITURES_MULTILIGNES,
  GET_ECRITURES_MANUELLES } from "routes/api/endpoints";

const PLAN_COMPTABLE_API_ROUTE = process.env.REACT_APP_API_URL + '/v1/plancomptable_bydossier/';

const clientApi = ApiMananger.injectEndpoints({
    endpoints: (build) => ({

    getLivreJournal: build.query({
        query: ({dossier_id, date_debut, date_fin, journal}) => {
          let url = `${GET_LIVRE_JOURNAL}?dossier_id=${dossier_id}`;
          if (date_debut) url += `&date_debut=${date_debut}`;
          if (date_fin) url += `&date_fin=${date_fin}`;
          if (journal) url += `&journal=${journal}`;
          return url;
        },
        providesTags: [INVALIDATE_CLIENT],
    }),
    getEcrituresMultilignes: build.query({
        query: ({dossier_id, journal}) => {
          let url = `${ECRITURES_MULTILIGNES}?dossier_id=${dossier_id}`;
          if (journal) url += `&journal=${journal}`;
          return url;
        },
        providesTags: [INVALIDATE_CLIENT],
    }),
    getGrandLivre: build.query({
      query: ({dossier_id, date_debut, date_fin}) => {
        let url = `${GET_Grand_Livre}?dossier_id=${dossier_id}`;
        if (date_debut) url += `&date_debut=${date_debut}`;
        if (date_fin) url += `&date_fin=${date_fin}`;
        return url;
      },
      providesTags: [INVALIDATE_CLIENT],
    }),
    getGrandLivreTiers: build.query({
      query: ({dossier_id, date_debut, date_fin, type, tiers_id}) => {
        let url = `${GET_GRAND_LIVRE_TIERS}?dossier_id=${dossier_id}`;
        if (date_debut) url += `&date_debut=${date_debut}`;
        if (date_fin) url += `&date_fin=${date_fin}`;
        if (type) url += `&type=${type}`;
        if (tiers_id) url += `&tiers_id=${tiers_id}`;
        return url;
      },
      providesTags: [INVALIDATE_CLIENT],
    }),
    getBalance: build.query({
      query: ({dossier_id, date_debut, date_fin}) => {
        let url = `${GET_BALANCE_GENERAL}?dossier_id=${dossier_id}`;
        if (date_debut) url += `&date_debut=${date_debut}`;
        if (date_fin) url += `&date_fin=${date_fin}`;
        return url;
      },
      providesTags: [INVALIDATE_CLIENT],
    }),
    getBilanComptable: build.query({
      query: ({dossier_id, date_debut, date_fin}) => {
        let url = `${GET_BILAN_COMPTABLE}?dossier_id=${dossier_id}`;
        if (date_debut) url += `&date_debut=${date_debut}`;
        if (date_fin) url += `&date_fin=${date_fin}`;
        return url;
      },
      providesTags: [INVALIDATE_CLIENT],
    }),
    getBilan: build.query({
      query: ({dossier_id, date_debut, date_fin}) => {
        let url = `${GET_BILAN}?dossier_id=${dossier_id}`;
        if (date_debut) url += `&date_debut=${date_debut}`;
        if (date_fin) url += `&date_fin=${date_fin}`;
        return url;
      },
      providesTags: [INVALIDATE_CLIENT],
    }),
    getEcrituresManuelles: build.query({
      query: ({ dossier_id, date_debut, date_fin }) => {
        let url = `${GET_ECRITURES_MANUELLES}?dossier_id=${dossier_id}`;
        if (date_debut) url += `&date_debut=${date_debut}`;
        if (date_fin) url += `&date_fin=${date_fin}`;
        return url;
      },
      providesTags: [INVALIDATE_CLIENT],
    }),
    getCompteResultat: build.query({
      query: ({dossier_id, date_debut, date_fin}) => {
        let url = `${GET_COMPTES_RESULTAT}?dossier_id=${dossier_id}`;
        if (date_debut) url += `&date_debut=${date_debut}`;
        if (date_fin) url += `&date_fin=${date_fin}`;
        return url;
      },
      providesTags: [INVALIDATE_CLIENT],
    }),
    getBilanDetail: build.query({
      query: ({bilan_id}) => `${GET_BILAN}${bilan_id}/?detail=true`,
      providesTags: [INVALIDATE_CLIENT],
    }),
    getBilanStructure: build.query({
      query: () => `${GET_BILAN_STRUCTURE}`,
      providesTags: [INVALIDATE_CLIENT],
    }),
    getCodesComptables: build.query({
      query: () => `${GET_CODES_COMPTABLES}`,
      providesTags: [INVALIDATE_CLIENT],
    }),
    getCodes: build.query({
      query: ({dossier_client}) => `${GET_CODES}?dossier_client=${dossier_client}&page_size=2000`,
      providesTags: [INVALIDATE_CLIENT],
    }),
    getCodesFournisseurs: build.query({
      query: () => `${GET_CODES_COMPTABLES}fournisseurs/`,
      providesTags: [INVALIDATE_CLIENT],
    }),
    getCodesClients: build.query({
      query: () => `${GET_CODES_COMPTABLES}clients/`,
      providesTags: [INVALIDATE_CLIENT],
    }),
    getCodesSalaries: build.query({
      query: () => `${GET_CODES_COMPTABLES}salaries/`,
      providesTags: [INVALIDATE_CLIENT],
    }),
    getCodesTiers: build.query({
      query: () => `${GET_CODES_COMPTABLES}tiers/`,
      providesTags: [INVALIDATE_CLIENT],
    }),
    getPlanComptableFiles: build.query({
      query: (dossier_id) => `${PLAN_COMPTABLE_API_ROUTE}?dossier=${dossier_id}`,
      providesTags: [INVALIDATE_PLAN_COMPTABLE],
    }),


  }),
});

export const {
  useGetGrandLivreQuery,
  useGetGrandLivreTiersQuery,
  useGetLivreJournalQuery,
  useGetBilanStructureQuery,
  useGetBilanComptableQuery,
  useGetCompteResultatQuery,
  useGetBalanceQuery,
  useGetBilanQuery,
  useGetEcrituresManuellesQuery,
  useGetEcrituresMultilignesQuery,
  useGetBilanDetailQuery,
  useGetCodesComptablesQuery,
  useGetCodesQuery,
  useGetCodesClientsQuery,
  useGetCodesFournisseursQuery,
  useGetCodesSalariesQuery,
  useGetCodesTiersQuery,
  useGetPlanComptableFilesQuery
} = clientApi;
